const adminApiBaseUrl =
  process.env.REACT_APP_PAYMENT_API_URL ||
  'https://southamerica-east1-coloniadeferiasss.cloudfunctions.net/paymentApi';

export interface VagasConfig {
  periodo: string;
  limite: number;
  confirmadas: number;
  restantes: number;
  encerrado: boolean;
}

export const fetchVagasConfig = async (): Promise<VagasConfig> => {
  const response = await fetch(`${adminApiBaseUrl.replace(/\/$/, '')}/admin/vagas`);
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.error || 'Não foi possível carregar o limite de inscrições.');
  }
  const { periodo, limite, confirmadas, restantes, encerrado } = payload;
  return { periodo, limite, confirmadas, restantes, encerrado };
};

export const updateVagasLimite = async (limite: number): Promise<VagasConfig> => {
  const response = await fetch(`${adminApiBaseUrl.replace(/\/$/, '')}/admin/vagas`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ limite })
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.error || 'Não foi possível salvar o limite de inscrições.');
  }
  const { periodo, confirmadas, restantes, encerrado } = payload;
  return { periodo, limite, confirmadas, restantes, encerrado };
};

export const fetchSaldoAsaas = async (): Promise<number> => {
  const response = await fetch(`${adminApiBaseUrl.replace(/\/$/, '')}/admin/saldo-asaas`);
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.error || 'Não foi possível consultar o saldo no Asaas.');
  }
  return Number(payload.saldo) || 0;
};
